import { isWithinInterval } from 'date-fns';

export const openingHoursOfWeek = (state) => (state.collectivity ? state.collectivity.openingHoursOfWeek : false);
export const openingHoursToday = (state, getters) => {
  return getters.openingHoursOfWeek
    ? getters.openingHoursOfWeek.filter((openingsHoursOfDay) => openingsHoursOfDay.dayOfWeek === new Date().getDay())[0]
    : false;
};
export const isContactCenterOpen = (state, getters) => {
  return getters.openingHoursToday && getters.openingHoursToday.startTime
    ? isWithinInterval(new Date(), {
        start: new Date(new Date().toISOString().split('T')[0] + 'T' + getters.openingHoursToday.startTime + ':00'),
        end: new Date(new Date().toISOString().split('T')[0] + 'T' + getters.openingHoursToday.endTime + ':00'),
      })
    : false;
};

export const phoneNumber = (state) => (state.collectivity ? state.collectivity.phoneNumber : undefined);
export const isDefaultHours = (state) => (state.collectivity ? state.collectivity.isDefaultHours : true);
export const nextAvailableDate = (state) =>
  state.collectivity ? state.collectivity.nextAvailableDate.availableDate : false;
export const nextAvailableDateStartTime = (state) =>
  state.collectivity ? state.collectivity.nextAvailableDate.openingHours.startTime : false;
